import axios from 'axios'
import { userKey } from "@/config/global"


/*const success = res => res

const error = err => {
	
    if (401 === err.response.status) {
        window.location = '/'
    } else {
        return Promisse.reject(err)
    }
}
*/
//axios.interceptors.response.use(success, error)
axios.interceptors.response.use(res => {
	if(res.data.codigo == '41' || res.data.codigo == '44'){
		
		sessionStorage.removeItem(userKey)
		window.location = '/'

	}

	return res
})


axios.interceptors.request.use(config => {
	
	if(!config.url.endsWith('login.php') 
		&& !config.url.endsWith('validateToken.php') 
		&& !config.url.endsWith('validaToken.php') 
		&& !config.url.endsWith('recuperarSenha.php')
		&& !config.url.endsWith('atualizarSenha.php')
		&& !config.url.endsWith('validaTokenAtendimento.php')
		&& !config.url.endsWith('insertConfirmacao.php')
		&& config.url != "https://api.ipify.org?format=jsonnp&callback=?"){
		
		const json = sessionStorage.getItem(userKey)
		const userData = JSON.parse(json)
		config.headers.Authorization = `bearer ${userData.token}`
	}
	
	return config
})

